// Dominio: lista de espera de solicitudes

export const getListaEspera = async (baseUrl) => {
  const response = await fetch(`${baseUrl}getListaEspera`, {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error(`Error al obtener la lista de espera (${response.status})`);
  }
  return response.json();
};

export const createListaEspera = async (
  baseUrl,
  { empresa, idCliente, idTipoProducto, metrajeRequerido, idUsuario, idCotizacion }
) => {
  const queryParams = new URLSearchParams({
    empresa,
    idCliente,
    idTipoProducto,
    metrajeRequerido,
    idUsuario
  });
  if (idCotizacion) {
    queryParams.append("idCotizacion", idCotizacion);
  }

  const response = await fetch(
    `${baseUrl}createListaEspera?${queryParams.toString()}`,
    {
      method: "POST",
      credentials: "include"
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.mensaje || "Error al crear lista de espera");
  }
  return data;
};

export const updateListaEspera = async (baseUrl, listaEspera, headers) => {
  const response = await fetch(`${baseUrl}updateListaEspera`, {
    method: "PUT",
    headers,
    body: JSON.stringify(listaEspera),
    credentials: "include"
  });
  if (!response.ok) {
    throw new Error("Error saving the lista de espera");
  }
  return await response.json();
};
